import { apiPaths, getApiPath, httpStatus } from '../../../constants'
import { Api } from '../../../middlewares'
import { Logger, LoggerTypes } from '../../../utils'

// -- GET
export const GET_PROJECT_RESOURCES_SUCCESS = 'GET_PROJECT_RESOURCES_SUCCESS'
export const GET_PROJECT_RESOURCES_FAILURE = 'GET_PROJECT_RESOURCES_FAILURE'

// -- CREATE
export const CREATE_PROJECT_RESOURCE_SUCCESS = 'CREATE_PROJECT_RESOURCE_SUCCESS'
export const CREATE_PROJECT_RESOURCE_FAILURE = 'CREATE_PROJECT_RESOURCE_FAILURE'

// -- UPDATE
export const UPDATE_PROJECT_RESOURCE_SUCCESS = 'UPDATE_PROJECT_RESOURCE_SUCCESS'
export const UPDATE_PROJECT_RESOURCE_FAILURE = 'UPDATE_PROJECT_RESOURCE_FAILURE'

// -- DELETE
export const DELETE_PROJECT_RESOURCE_SUCCESS = 'DELETE_PROJECT_RESOURCE_SUCCESS'
export const DELETE_PROJECT_RESOURCE_FAILURE = 'DELETE_PROJECT_RESOURCE_FAILURE'

// -- SEARCH
export const SEARCH_PROJECT_RESOURCES = 'SEARCH_PROJECT_RESOURCES'

// -----------------------------------------------------------------------------

/**
 * SEARCH for a project resource attribute based on its name.
 *
 * @param {string} terms Text to be searched within the project resource.
 * @returns {Promise<array<object>>}
 */
export const searchProjectResources = (terms) => async (dispatch) => {
  dispatch({
    type: SEARCH_PROJECT_RESOURCES,
    data: terms
  })
}

/**
 * GET the list of all the resources that belong to a specific project.
 * @param {uuid} pid Project ID
 * @returns {Promise<array<object>>}
 */
export const getProjectResources = (pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_RESOURCE_LIST, { pid })
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] resourcesActions.getProjectResources()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_PROJECT_RESOURCES_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: GET_PROJECT_RESOURCES_FAILURE,
    data: result.data
  })
}

/**
 * CREATE a project resource.
 *
 * @param {object} newResource New resource to be created
 * @param {uuid} pid Project ID
 * @returns {object}
 */
export const createProjectResource = (newResource, pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_RESOURCE_CREATE, { pid })
  const api = new Api(path)
  const result = await api.create(newResource)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] resourcesActions.createProjectResource()', { path, newResource, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_PROJECT_RESOURCE_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_PROJECT_RESOURCE_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific project resource attribute.
 *
 * @param {object} newResource Resource object that will replace the previous one.
 * @param {uuid} rid Project resource ID.
 * @param {uuid} pid Project ID.
 * @returns {Promise<object>}
 */
export const updateProjectResource = (newResource, rid, pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_RESOURCE_UPDATE, { pid, rid })
  const api = new Api(path)
  const result = await api.update(newResource)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] resourcesActions.updateProjectResource()', { path, newResource, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_PROJECT_RESOURCE_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_PROJECT_RESOURCE_FAILURE,
    data: result.data
  })
}

/**
 * DELETE a specific project resource.
 *
 * @param {uuid} rid Project resource ID.
 * @param {uuid} pid Project ID.
 * @returns {Promise<object>}
 */
export const deleteProjectResource = (rid, pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_RESOURCE_DELETE, { pid, rid })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] resourcesActions.deleteProjectResource()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_PROJECT_RESOURCE_SUCCESS,
      data: rid
    })
  }

  return dispatch({
    type: DELETE_PROJECT_RESOURCE_FAILURE,
    data: result.data
  })
}
